
$models.tags = {
	
	getItem : function() { },
	
	getList : function($params, $callback) {
		$models.all.getDataFromAPI('tags.json', $params, $callback, 'Unable to load the list of tags at this time');
	},
	
	getSize : function() { }
	
};



// WEBPACK FOOTER //
// ./src/js/models/tags.js